import type { RootState } from '@/store/store';

// Selectores para el map editor
export const selectShapes = (state: RootState) => state.mapEditor?.shapes || [];
export const selectSelectedShapeId = (state: RootState) => state.mapEditor?.selectedShapeId || null;
export const selectSelectedShapeIds = (state: RootState) => state.mapEditor?.selectedShapeIds || [];
export const selectTool = (state: RootState) => state.mapEditor?.tool || 'select';
export const selectBackgroundImage = (state: RootState) => state.mapEditor?.backgroundImage || null;
export const selectCanvasDimensions = (state: RootState) =>
  state.mapEditor?.dimensions || { width: 1200, height: 800 };
export const selectZoom = (state: RootState) => state.mapEditor?.zoom || 1;
export const selectIsDirty = (state: RootState) => state.mapEditor?.isDirty || false;
export const selectSelectedShape = (state: RootState) => {
  const shapes = state.mapEditor?.shapes || [];
  const selectedShapeId = state.mapEditor?.selectedShapeId;
  if (!selectedShapeId) return null;
  return shapes.find((s) => s.id === selectedShapeId) || null;
};
